<template>
  <div v-if="access !== null">
    <!-- TABLE ACTION ROW -->
    <header class="w-full">
      <div class="vx-row justify-between items-center">
        <section class="mb-base vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full">
          <div class="w-full gap-2 flex justify-start items-center">
            <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="dialogDelete"
                    v-if="access.delete === 1"
                  >
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown> -->
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">{{ `entries ${limit}` }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="(item, index) in limitDataTables"
                  :key="index"
                  @click="limit = item"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </section>
        <section class="mb-base vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full">
          <div class="vx-row justify-end gap-0 flex-wrap items-center">
            <!-- <vs-button class="vx-col sm:w-full lg:w-1/2" @click.prevent="getData(true)">{{
              `Export Data ${mitra_id !== null ? "Pemasukan" : "Pengeluaran"}`
            }}</vs-button> -->
            <v-select
              :options="statusList"
              :reduce="(v) => v.id"
              class="vx-col sm:w-full lg:w-1/2"
              label="text"
              v-model="statusSelect"
              placeholder="Pilih Status Aproval"
            />
            <!-- <vs-input
              class="vx-col sm:w-full lg:w-1/2"
              v-model="search"
              @keypress="onlyNumber"
              placeholder="Cari jumlah pembayaran"
            /> -->
          </div>
        </section>
      </div>

      <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      <div
        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
      ></div>
    </header>

    <main ref="loadAprovalPenyaluran">
      <vs-table stripe :data="penyalurans" v-model="selected" :max-items="limit">
        <template slot="thead">
          <vs-th>User</vs-th>
          <vs-th>Jenis Transaksi</vs-th>
          <vs-th>Dana</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Aksi</vs-th>
          <!-- <vs-th>Aksi</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].user">
              {{ data[indextr].user ? data[indextr].user.name : "(Kosong)" }}
            </vs-td>
            <vs-td :data="data[indextr].jenis_transaksi">
              {{
                data[indextr].jenis_transaksi
                  ? data[indextr].jenis_transaksi.name
                  : "(Kosong)"
              }}
            </vs-td>
            <vs-td :data="data[indextr].jumlah_pembayaran">
              {{ data[indextr].jumlah_pembayaran | toCurrency }}
            </vs-td>

            <vs-td
              :data="data[indextr].status"
              :style="data[indextr].status === 1 ? 'color: orange;' : 'color: green;'"
            >
              {{ data[indextr].status === 1 ? "Pending" : "Disetujui" }}
            </vs-td>
            <vs-td>
              <div class="flex justify-start gap-2">
                <vs-button
                  v-if="access.update === 1"
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click="openPopUp(data[indextr])"
                >
                </vs-button>
                <!-- <vs-button
                  v-if="access.delete === 1"
                  color="danger"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="dialogDelete(data[indextr].id, data[indextr].name)"
                >
                </vs-button> -->
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </main>
    <footer>
      <div class="justify-end mt-2">
        <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
      </div>
    </footer>
  </div>
</template>

<script>
import TransaksiPopup from "@/views/transaksi/component/TransaksiPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";

export default {
  components: {
    TransaksiPopup,
  },
  props: {
    jenis_id: { type: Number, default: null },
  },
  data() {
    return {
      emptyImage,
      params: {},
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      statusList: [
        {
          id: 1,
          text: "Pending",
        },
        {
          id: 2,
          text: "Disetujui",
        },
      ],
      statusSelect: null,
      kategoriList: [],
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      passData: null,
      currentPg: 1,
      metodePembayaran: [],
      jenisPembayaran: [],
      selected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      penyalurans: [],
      access: null,
      search: "",
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess;
    },
    totalPage() {
      let pages = this.$store.state.penyaluran.totalRecords / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  watch: {
    mitra_id() {
      this.getData(false);
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData(false);
    },
    statusSelect() {
      if (this.statusSelect !== null) {
        this.params = {
          status: this.statusSelect,
        };
      } else {
        this.params = {};
      }

      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData(false);
    },
  },
  methods: {
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    loadData(val) {
      if (val) {
        this.getData(false);
      }
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadAprovalPenyaluran,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("penyaluran/cudPenyaluran", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Penyaluran ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData(false);
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadAprovalPenyaluran);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadAprovalPenyaluran,
        color: "primary",
      });
      this.$store
        .dispatch("penyaluran/getPenyaluran", {
          ...this.params,
          jenis_id: this.jenis_id,
          ...this.pagination,
        })
        .then((v) => {
          this.penyalurans = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close(this.$refs.loadAprovalPenyaluran);
        });
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/penyaluran/aproval"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/penyaluran/aproval"
        );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
